import { appSetAlert, appSetLoading } from "store/actions/appAction";
import axios from "../axios/axios";
import { errorDispatcher } from "helpers";

export const apiSetFiscalYear = (token, data, callback) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .post(`/accountings/closeFiscalYear`, data, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      callback && callback(response);
      dispatch(appSetAlert(response.data.message, "success"));
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
export const apiGetGrosProfit = (token, callback) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .get(`/reports/profitAndLoss`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      callback && callback(response);
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
